import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <img src="/logo.png" alt="Memorial Parque Dourados" className="footer-logo" />
          <span className="footer-city">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
            Dourados - MS
          </span>
        </div>
        <p className="footer-phrase">Respeito, cuidado e memória para sempre.</p>
        <p className="footer-copy">
          <Link to="/privacidade" style={{ color: 'inherit', textDecoration: 'underline', marginRight: 12 }}>
            Termo de Privacidade
          </Link>
          © {new Date().getFullYear()} Memorial Parque Dourados — Dourados-MS
        </p>
      </div>
    </footer>
  );
}
